import { ApolloClient } from '@apollo/client';
import {
  ACTIVITIES_CONTENT_STATUS_DRAFT,
  ACTIVITIES_CONTENT_STATUS_PUBLISHED,
  LANGUAGE_CODE_EN_AU,
} from 'global/constants';

export function updateActivitiesStatusInCache({
  client,
  contentId,
  typename,
}: {
  client: ApolloClient<any>;
  contentId: number;
  typename: string;
}) {
  client.cache.modify({
    id: client.cache.identify({
      __typename: typename,
      id: contentId,
      language: LANGUAGE_CODE_EN_AU,
      version: ACTIVITIES_CONTENT_STATUS_DRAFT,
    }),
    fields: {
      hasUnpublishedChanges: () => false,
      status: () => ACTIVITIES_CONTENT_STATUS_PUBLISHED,
    },
  });
}
